"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityFeedbackReasonsDtoSchema = exports.SubmitAvailabilityFeedbackRequestSchema = exports.AVAILABILITY_FEEDBACK_COMMENT_MAX_LENGTH = exports.AvailabilityDeviationDirectionSchema = exports.ReportedAvailabilityStatusSchema = exports.REPORTED_AVAILABILITY_STATUSES = exports.AvailabilityFeedbackReasonKeySchema = exports.AvailabilityFeedbackReasonKey = void 0;
const zod_1 = require("zod");
const geo_1 = require("./geo");
const rest_area_1 = require("./rest-area");
var AvailabilityFeedbackReasonKey;
(function (AvailabilityFeedbackReasonKey) {
    AvailabilityFeedbackReasonKey["DETACHED_TRAILERS"] = "DETACHED_TRAILERS";
    AvailabilityFeedbackReasonKey["NON_TRUCK_VEHICLES"] = "NON_TRUCK_VEHICLES";
    AvailabilityFeedbackReasonKey["BLOCKING_TRUCKS"] = "BLOCKING_TRUCKS";
    AvailabilityFeedbackReasonKey["PARKED_ON_RAMP"] = "PARKED_ON_RAMP";
    AvailabilityFeedbackReasonKey["AREA_CLOSED"] = "AREA_CLOSED";
    AvailabilityFeedbackReasonKey["MANY_FREE"] = "MANY_FREE";
    AvailabilityFeedbackReasonKey["INFORMAL_PARKING_POSSIBLE"] = "INFORMAL_PARKING_POSSIBLE";
    AvailabilityFeedbackReasonKey["SITE_REOPENED"] = "SITE_REOPENED";
    AvailabilityFeedbackReasonKey["LAYOUT_CHANGED"] = "LAYOUT_CHANGED";
    AvailabilityFeedbackReasonKey["OTHER"] = "OTHER";
})(AvailabilityFeedbackReasonKey || (exports.AvailabilityFeedbackReasonKey = AvailabilityFeedbackReasonKey = {}));
exports.AvailabilityFeedbackReasonKeySchema = zod_1.z.nativeEnum(AvailabilityFeedbackReasonKey);
exports.REPORTED_AVAILABILITY_STATUSES = [
    rest_area_1.SiteAvailabilityStatus.Full,
    rest_area_1.SiteAvailabilityStatus.AlmostFull,
    rest_area_1.SiteAvailabilityStatus.SpacesAvailable,
];
exports.ReportedAvailabilityStatusSchema = rest_area_1.SiteAvailabilityStatusSchema.refine((status) => status !== rest_area_1.SiteAvailabilityStatus.Unknown, { message: 'unknown is not a reportable availability status' });
exports.AvailabilityDeviationDirectionSchema = zod_1.z.enum(['worse', 'better']);
exports.AVAILABILITY_FEEDBACK_COMMENT_MAX_LENGTH = 280;
// Field names `details` / `infoDisplayed` and the optionality of every newer field are load-bearing:
// already-installed native apps still post `{ siteId, isCorrect, details, infoDisplayed }` only.
const SubmitAvailabilityFeedbackRequestBaseSchema = zod_1.z.object({
    siteId: zod_1.z.string().min(1).max(50),
    isCorrect: zod_1.z.boolean(),
    details: exports.ReportedAvailabilityStatusSchema.nullable().optional(),
    infoDisplayed: rest_area_1.SiteAvailabilityStatusSchema,
    reasons: zod_1.z
        .array(exports.AvailabilityFeedbackReasonKeySchema)
        .refine((reasons) => new Set(reasons).size === reasons.length, { message: 'Duplicate reasons are not allowed' })
        .optional(),
    comment: zod_1.z.string().trim().max(exports.AVAILABILITY_FEEDBACK_COMMENT_MAX_LENGTH).nullable().optional(),
    displayedFreeCount: zod_1.z.number().int().min(0).nullable().optional(),
    totalCount: zod_1.z.number().int().min(0).nullable().optional(),
    dataSource: zod_1.z.nativeEnum(rest_area_1.DataOrigin).nullable().optional(),
    gpsPosition: geo_1.coordSchema.nullable().optional(),
});
exports.SubmitAvailabilityFeedbackRequestSchema = SubmitAvailabilityFeedbackRequestBaseSchema.refine((request) => request.isCorrect || Boolean(request.details), { message: 'details is required when isCorrect is false', path: ['details'] });
// Drops keys this client version does not know yet, so adding a chip server-side never breaks
// the reason step of already-installed apps.
const KnownReasonKeysSchema = zod_1.z
    .array(zod_1.z.string())
    .transform((keys) => keys.flatMap((key) => {
    const parsed = exports.AvailabilityFeedbackReasonKeySchema.safeParse(key);
    return parsed.success ? [parsed.data] : [];
}));
exports.AvailabilityFeedbackReasonsDtoSchema = zod_1.z.object({
    worse: KnownReasonKeysSchema,
    better: KnownReasonKeysSchema,
});
//# sourceMappingURL=availability-feedback.js.map